import { Route, Routes } from "react-router-dom"
import Navbar from "./components/Navbar/Navbar"
import Footer from "./components/Footer/Footer"
import Home from "./pages/Home"
import About from "./pages/About"
import GetInvolved from "./pages/GetInvolved"
import Donate from "./pages/Donate"
import Blog from "./pages/Blog"
import Contact from "./pages/Contact"
import Programs from "./pages/Programs"
import Gallery from "./pages/Gallery"
import ScrollToTop from "./components/common/ScrollToTop"



const App = () => {
  return (
    <div className="category min-h-screen flex flex-col">
  <Navbar />
  <ScrollToTop/>
  <div className="flex-1 mt-10">
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/programs" element={<Programs />} />
      <Route path="/get-involved" element={<GetInvolved />} />
      <Route path="/donate" element={<Donate />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  </div>
  
  <Footer />
</div>

  )
}

export default App